export class ArrayHelper {
  static getNewElementsOnly = <T>(oldArray: T[], newArray: T[]): T[] => {
    return newArray.filter((element) => !oldArray.includes(element));
  };

  static sumElements = (array: number[]): number => {
    return array.reduce((a, b) => a + b, 0);
  };
}
